<template>
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <div
      :class="{
        opened: opened.indexOf('removeFromGroups') >= 0,
        'last-active': opened.indexOf('removeFromGroups') == opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleGroupAddConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="removeFromGroups()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("odebratZeSkupiny") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2 v-if="endpoints">
          {{ $filters.firstUpper($t("odebrat")) }} {{ endpoints.length }}
          {{
            $filters.inflection(
              endpoints.length,
              $t("inflection_priradit_1_Endpoint"),
              $t("inflection_priradit_2_4_Endpoint"),
              $t("inflection_priradit_5_Endpoint")
            )
          }}
          {{ $t("zeSkupiny") }}
        </h2>
      </div>
      <div class="side-box__content">
        <div class="d-flex side-box__row align-items-start">
          <span class="side-box__content__label mt-sm-3">{{ $t("odebratZeSkupin") }}</span>
          <div class="w-100 side-box__content__input ml-3">
            <div class="text-right ml-3" />
            <div class="side-box__content__groups mb-1">
              <div
                v-for="selectedG in selectedGroups"
                :key="selectedG.deviceGroupId"
                class="d-flex side-box__content__group justify-content-between mb-2"
              >
                <span class="mr-1 link-gray font-weight-normal">
                  <span>{{ selectedG.deviceGroupName }}</span>
                </span>
                <div class="pointer" @click="addRemoveGroup(selectedG)">
                  <img class="" src="@/assets/icons/actions/ico-ico-delete-gray.svg" />
                </div>
              </div>
            </div>
            <div
              v-if="selectedGroups.length < 1 || selectGroupVisible == true"
              class="side-box__content__input custom-control__select"
            >
              <div
                :class="{ opened: groupsOpened }"
                class="side-box__content__input custom-control__select__selected"
                @click="groupsOpened = groupsOpened ? false : true"
              >
                <span class="gray-text">{{ $t("vyberteSkupinuZeSeznamu") }}</span>
              </div>
              <div :class="{ opened: groupsOpened }" class="custom-control__select__options">
                <div
                  v-for="group in loadedGroups"
                  :key="group.deviceGroupId"
                  class="custom-control__select__option d-flex align-items-center"
                  @click="
                    () => {
                      addRemoveGroup(group)
                      selectGroupVisible = false
                    }
                  "
                >
                  <div class="check">
                    <img v-if="selectedGroups.indexOf(group) > -1" class="" src="@/assets/icons/check.svg" />
                  </div>
                  <span class="font-weight-light">{{ group.deviceGroupName }}</span>
                </div>
              </div>
            </div>
            <div v-else>
              <a v-if="selectedGroups.length < loadedGroups.length" class="" @click="selectGroupVisible = true">
                {{ $t("odebratZDalsiSkupiny") }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      :class="{
        opened: opened.indexOf('newGroup') >= 0,
        'last-active': opened.indexOf('newGroup') == opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleGroupConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="createGroup()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("vytvoritRoutovaciSkupinu") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2>{{ $t("novaRoutovaciSkupina") }}</h2>
      </div>
      <div class="side-box__content">
        <div v-if="errors.group" class="text-danger">
          {{ errors.group }}
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label">{{ $t("nazevSkupiny") }}</span>
          <div
            :class="{ 'has-error': errors.group && !newGroup.deviceGroupName }"
            class="side-box__content__input custom-control__custom-input ml-3"
          >
            <span v-if="!newGroup.deviceGroupName" class="placeholder">{{ $t("zadejteNazevRotovaciSkupiny") }}</span>
            <input
              v-model="newGroup.deviceGroupName"
              autofocus
              class="w-100"
              maxlength="30"
              minlength="1"
              placeholder=""
              type="text"
            />
          </div>
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label">{{ $t("popis") }}</span>
          <div class="side-box__content__input custom-control__custom-input ml-3">
            <span v-if="!newGroup.deviceGroupDesc" class="placeholder">{{ $t("volitelnyPopisRoutovaciSkupiny") }}</span>
            <input
              v-model="newGroup.deviceGroupDesc"
              autofocus
              class="w-100"
              maxlength="255"
              placeholder=""
              type="text"
            />
          </div>
        </div>
        <div class="my-4 text-center">
          <a
            :class="{ opened: parametersTagsOpened }"
            class="atom-form-group__toggler"
            @click="parametersTagsOpened = parametersTagsOpened ? false : true"
          >
            {{ $t("parametryATagy") }}
          </a>
          <div :class="{ opened: parametersTagsOpened }" class="atom-form-group__content">
            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label">{{ $t("vlastniParametry") }}</span>
              <div class="side-box__content__input custom-control__select ml-3">
                <div
                  :class="{ opened: parametersOpened }"
                  class="custom-control__select__selected"
                  @click="parametersOpened = parametersOpened ? false : true"
                >
                  <span v-if="selectedParameters.length < 1" class="gray-text">
                    {{ $t("vyberteZeSvychParametru") }}
                  </span>
                  <span v-else>
                    <span v-for="(selectedParameter, index) in selectedParameters" :key="index" class="mr-1">
                      {{ selectedParameter }}
                      <span v-if="index < selectedParameters.length - 1">,</span>
                    </span>
                  </span>
                </div>
                <div :class="{ opened: parametersOpened }" class="custom-control__select__options">
                  <div
                    class="custom-control__select__option d-flex align-items-center"
                    @click="addRemoveParameter('Parametr1')"
                  >
                    <div class="check">
                      <img
                        v-if="selectedParameters.indexOf('Parametr1') > -1"
                        class=""
                        src="@/assets/icons/check.svg"
                      />
                    </div>
                    <span class="font-weight-light">Parametr1</span>
                  </div>
                  <div
                    class="custom-control__select__option d-flex align-items-center"
                    @click="addRemoveParameter('Parametr2')"
                  >
                    <div class="check">
                      <img
                        v-if="selectedParameters.indexOf('Parametr2') > -1"
                        class=""
                        src="@/assets/icons/check.svg"
                      />
                    </div>
                    <span class="font-weight-light">Parametr2</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label">{{ $t("tagy") }}</span>
              <div class="side-box__content__input custom-control__custom-input ml-3">
                <span v-if="!writtenGroupTags" class="placeholder">{{ $t("zadejteTag") }}</span>
                <input v-model="writtenGroupTags" autofocus class="w-100" placeholder="" type="text" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SaveConfirmationModal
      :opened="openedGroupAddConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleGroupAddConfirmation"
      @no="closeBox('removeFromGroups')"
      @yes="removeFromGroups()"
    />
    <SaveConfirmationModal
      :opened="openedGroupConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleGroupConfirmation"
      @no="closeBox('newGroup')"
      @yes="createGroup()"
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
  </div>
</template>

<script>
import _ from "lodash"
import axios from "axios"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import { useProjectStore } from "@/store/modules/project"

export default {
  components: {
    SaveConfirmationModal,
    ErrorModal
  },
  props: {
    tags: Array,
    endpoints: Array,
    opened: Array
  },
  setup() {
    const projectStore = useProjectStore()

    return { projectStore }
  },
  data() {
    return {
      loadedGroups: [],
      selectedGroups: [],
      groupsOpened: false,
      parametersTagsOpened: false,
      parametersOpened: false,
      selectedParameters: [],
      tagsOpened: false,
      selectedEndpointTags: [],
      selectedGroupTags: [],
      groupTags: [],
      writtenEndpointTags: "",
      writtenGroupTags: "",
      newGroup: {
        projectId: "",
        deviceGroupName: "",
        deviceGroupDesc: ""
      },
      openedGroupAddConfirmation: false,
      openedGroupConfirmation: false,
      errors: {
        endpoint: "",
        group: ""
      },
      selectGroupVisible: false,
      errorsToTranslate: [],
      openedError: false
    }
  },
  computed: {
    project() {
      return this.projectStore.selectedProject
    }
  },
  watch: {
    slides() {},
    project() {
      // TODO delete this.loadGroups();
    },
    writtenEndpointTags() {
      this.createTagsArray()
    },
    opened() {
      if (this.opened.indexOf("removeFromGroups") > -1) {
        this.loadGroups()
      }
    }
  },
  mounted() {
    if (this.project) {
      // TODO delete this.loadGroups();
    }
  },
  methods: {
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      if (box == undefined) {
        this.resetForm()
        this.$emit(box)
      } else {
        this.resetForm()
        this.$emit("closeBox", box)
      }
    },
    resetForm() {
      this.selectedGroups = []
      this.groupsOpened = false
    },
    loadGroups() {
      console.log("loadGroups")
      console.log(this.endpoints)
      this.loadedGroups = []
      axios
        .get(
          process.env.VUE_APP_API +
            "/device-groups?sort=%2BdeviceGroupName&search=" +
            this.project.projectId +
            "&limit=1000",
          {}
        )
        .then((result) => {
          result.data.data.forEach((group) => {
            this.endpoints.forEach((endpoint) => {
              if (endpoint.deviceGroups.filter((e) => e.deviceGroupId === group.deviceGroupId).length > 0) {
                if (this.loadedGroups.indexOf(group) == -1) this.loadedGroups.push(group)
              }
            })
          })
          //console.log("result.data.data");
          //console.log(groupData);
          //this.loadedGroups = groupData;
          this.getAllTags()
        })
        .catch(() => {})
    },
    addRemoveGroup(group) {
      if (this.selectedGroups.indexOf(group) == -1) {
        this.selectedGroups.push(group)
      } else {
        this.selectedGroups.splice(this.selectedGroups.indexOf(group), 1)
      }
      //
    },
    addRemoveParameter(parameter) {
      if (this.selectedParameters.indexOf(parameter) == -1) {
        this.selectedParameters.push(parameter)
      } else {
        this.selectedParameters.splice(this.selectedParameters.indexOf(parameter), 1)
      }
    },
    addRemoveTag(tag) {
      if (this.writtenEndpointTags.indexOf(tag) == -1) {
        this.writtenEndpointTags += tag
      }
    },
    createTagsArray() {
      let written = this.writtenEndpointTags.split(",")
      let selected = []
      written.forEach((tag) => {
        let trimmed = tag.trim()
        selected.push(trimmed)
      })
      this.selectedEndpointTags = selected
    },
    removeFromGroups() {
      this.errorsToTranslate = []
      let promises = []
      let notifications = []
      this.selectedGroups.forEach((group) => {
        this.endpoints.forEach((endpoint) => {
          if (endpoint.deviceGroups.filter((e) => e.deviceGroupId === group.deviceGroupId).length > 0) {
            promises.push(
              axios
                .delete(
                  process.env.VUE_APP_API +
                    "/device-groups/" +
                    group.deviceGroupId +
                    "/endpoints/" +
                    endpoint.custDestId +
                    "/assign",
                  {}
                )
                .then((response) => {
                  if (response.status == 204) {
                    notifications.push({
                      text: "notificationEndpointGroupRemove",
                      error: false,
                      params: {
                        custDestId: endpoint.custDestId,
                        custDestName: endpoint.custDestName,
                        deviceGroupId: group.deviceGroupId,
                        deviceGroupName: group.deviceGroupName
                      }
                    })
                    endpoint.deviceGroups = endpoint.deviceGroups.filter((e) => e.deviceGroupId != group.deviceGroupId)
                    this.closeBox("removeFromGroups")
                    this.$emit("reloadItems")
                    //this.$emit("loadGoup");
                  }
                })
                .catch((error) => {
                  let message = error.data.errors[0]
                  error.data.errors = []
                  error.data.errors.push({
                    message: message,
                    attribute: {
                      custDestId: endpoint.custDestId,
                      custDestName: endpoint.custDestName
                    }
                  })
                  this.errorsToTranslate.push(error.data)
                  this.closeBox("removeFromGroups")
                })
            )
          } else {
            this.closeBox("removeFromGroups")
          }
        })
      })
      Promise.all(promises).then(() => {
        this.$store.commit("modals/setGlobalNotification", notifications)
        this.openedError = true
      })
    },
    createGroup() {
      if (this.newGroup.deviceGroupName) {
        axios
          .post(process.env.VUE_APP_API + "/device-groups", this.newGroup)
          .then((result) => {
            let groupId = result.data.deviceGroupId

            let createdGroup = this.newGroup
            createdGroup.deviceGroupId = groupId

            this.loadedGroups.push(createdGroup)
            this.selectedGroups.push(createdGroup)
            this.$emit("closeBox", "newGroup")
          })
          .catch(() => {})
      } else {
        this.errors.group = this.$t("fillAllFieldsError")
      }
    },
    getAllTags() {
      this.groupTags = _(this.loadedGroups)
        .flatMap((f) => f.tags)
        .sortedUniq()
        .value()
    },
    toggleGroupAddConfirmation() {
      this.openedGroupAddConfirmation = this.openedGroupAddConfirmation ? false : true
    },
    toggleGroupConfirmation() {
      this.openedGroupConfirmation = this.openedGroupConfirmation ? false : true
    }
  }
}
</script>

<style lang="scss" scoped></style>
